/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import * as helpers from '@ion/core/src/security/helpers';
import {Link} from '@ion/core/src/types/entities';

export const getFilePermissions = (
  permissions: Link[],
  action: string
) => permissions?.find(({title}) => title === action);

// simply provides a re-export of all core security helpers ...
// eslint-disable-next-line no-barrel-files/no-barrel-files
export {helpers};
